import React, { memo } from 'react'

const EmptySpace = () => {
    return (
        <section className="d-none d-md-block empty-space">
        </section>
    )
}

export default memo(EmptySpace);
